<!--
 @Description: 账号激活和忘记密码 设置密码
-->
<template>
  <div>
    <NavBar
      :title="$t(`webapp.menus.${$route.meta.field}`)"
      :left-arrow="$route.meta.isShowArrow"
      @click-left="$router.back()"
      nav-bar-icon-color="#000"
      class="navbarSelf"
    ></NavBar>
    <div class="box">
      <div class="box-set">
        <div class="title">
          {{ $t("webapp.password.set_tip")
          }}<span class="name">{{ bindUserName }}</span>
        </div>
        <Form class="vertical_self_form" @submit="onSubmit">
          <Field
            v-model="form.password"
            name="password"
            maxlength="32"
            :placeholder="$t('base.password.new_placeholder')"
            @input="handleInput"
            :show-error-message="false"
            :scroll-to-error="true"
            :rules="[
              {
                required: true,
                message: $t('base.password.format_error'),
                validator: handlePass,
              },
            ]"
          />
          <div class="strength">
            {{ $t("base.password.strength") }}
            <div class="strength-box">
              <div class="flex">
                <span
                  class="text"
                  :style="{
                    color: form.passwordStrength == 3 ? '#7FE01A' : '#c3c0c0',
                  }"
                >
                  {{ $t("base.password.strength_strong") }}
                </span>
                <span
                  class="text"
                  :style="{
                    color: form.passwordStrength == 2 ? '#B2ED74' : '#dddddd',
                  }"
                >
                  {{ $t("base.password.strength_medium") }}
                </span>
                <span
                  class="text"
                  :style="{
                    color: form.passwordStrength == 1 ? '#D8F1BE' : '#ececec',
                  }"
                >
                  {{ $t("base.password.strength_weak") }}
                </span>
              </div>
              <div class="flex">
                <span
                  class="bg"
                  :style="{
                    background:
                      form.passwordStrength == 3 ? '#7FE01A' : '#c3c0c0',
                  }"
                >
                </span>
                <span
                  class="bg"
                  :style="{
                    background:
                      form.passwordStrength == 2 ? '#B2ED74' : '#dddddd',
                  }"
                >
                </span>
                <span
                  class="bg"
                  :style="{
                    background:
                      form.passwordStrength == 1 ? '#D8F1BE' : '#ececec',
                  }"
                >
                </span>
              </div>
            </div>
          </div>
          <Field
            v-model="form.surePassWord"
            name="surePassWord"
            :placeholder="$t('base.password.new_confirm_placeholder')"
            :show-error-message="false"
            :scroll-to-error="true"
            :rules="[
              {
                required: true,
                message: $t('base.password.again_error'),
                validator: handleSurePass,
              },
            ]"
          />
          <div style="margin-top: 30px">
            <Button round block type="info" native-type="submit">{{
              $t("base.btn.next_step")
            }}</Button>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import { Form, Field, Button, NavBar } from "vant";
import { toast } from "@/utils/toast";
import { commonAPI } from "@/apis";
import { PasswordStrength } from "@/mixins/password-mobile";

export default {
  name: "NewPassword",
  components: { Form, Field, Button, NavBar },
  mixins: [PasswordStrength],
  data() {
    return {
      bindUserName: "",
      form: {},
      pswSetInfo: {},
    };
  },

  created() {
    let obj = JSON.parse(localStorage.getItem("ACTIVATE_INFO"));
    this.form = Object.assign({}, obj);
    console.log(this.form);
    // 账号激活带过来的数据
    this.type = this.$route.query.type;
    if (this.type == "forget") {
      this.userInfo = JSON.parse(localStorage.getItem("FORGET_INFO")) || {};
    } else if (this.type == "activate") {
      this.userInfo = JSON.parse(localStorage.getItem("ACTIVATE_INFO")) || {};
    } else {
      this.userInfo = JSON.parse(sessionStorage.getItem("user")) || {};
    }
    this.bindUserName = this.userInfo.username;

    this.getPswSet();
  },
  methods: {
    // 获取密码策略
    async getPswSet() {
      const { code, data, message } = await commonAPI.getAction(
        "setting/pass/get"
      );
      if (code == 0) {
        this.pswSetInfo = { ...data };
      } else {
        toast(message);
      }
    },

    handleInput(v) {
      this.handleStrength(v);
      // console.log(this.form.passwordStrength);
    },
    // 校验密码
    handlePass(value) {
      let reg1 = escape(value).includes("%u"); // 是否包含中文字符、汉字
      let reg2 = new RegExp(/\s+/g); // 是否包含空格
      if (reg1 || reg2.test(value)) {
        return false;
      }
      return true;
    },
    // 校验2次密码是否一样
    handleSurePass(val) {
      // console.log(val, this.form.password);
      // console.log(555, this.form.passwordStrength);
      return this.form.password == val;
    },
    // 激活成功发通知
    async handleSuccess() {
      const { code, message } = await commonAPI.getAction(
        `/user/active/sendMsg/${this.bindUserName}?secretKey=${this.form.secretKey}`
      );
      if (code == 0) {
        toast(message);
      } else {
        toast(message);
      }
    },
    async handleNextApi() {
      let params = {
        username: this.bindUserName,
        password: this.form.password,
        secretKey: this.form.secretKey,
        passwordStrength: this.form.passwordStrength,
        businessClassify: this.$router.query.businessClassify || "",
        captcha: this.$router.query.captcha || "",
        noticeClassify: this.$router.query.noticeClassify || "",
      };
      const { code, message } = await commonAPI.postAction(
        // "/user/active/changePassword",
        "/user/active/changePasswordNew",
        params
      );

      if (code == 0) {
        toast(message);
        if (this.type == "activate") {
          // 激活成功需要发送通知
          this.handleSuccess();
        }
      } else {
        toast(message);
      }

      this.$router.push({
        path: "/mwarnPassword",
        query: { status: code == 0 ? 1 : 0 }, //表示类型是设置密码成功
      });
    },
    async onSubmit() {
      // console.log("submit", this.form, this.dissatisfyMsg);
      let obj = this.pswSetInfo;
      let length = this.form.password.length;
      if (obj.mmcl == 1 && length < obj.zlrmmgzcd) {
        toast(
          `${this.$t("base.password.length_tip")}${this.$t(
            "base.punctuation.colon"
          )}${obj.zlrmmgzcd}`
        );
        return;
      }

      if (
        obj.mmcl == 2 &&
        (length < obj.tjrmmgzcd || !this.form.passwordStrength)
      ) {
        toast(
          `${this.$t("base.password.length_tip")}${this.$t(
            "base.punctuation.colon"
          )}${obj.tjrmmgzcd}${this.$t("base.punctuation.comma")}${this.$t(
            "base.password.includes_tip"
          )}${this.$t("base.punctuation.colon")}${this.dissatisfyMsg}`
        );
        return;
      }

      this.handleNextApi();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/base.scss";

::v-deep {
  .van-cell {
    box-shadow: inset 0px 1px 5px 0px rgba(33, 151, 231, 0.52);
    border-radius: 4px;
    border: 1px solid #2197e7;
  }
}

.box {
  color: #666666;
  padding: 10px 15px;
  .box-set {
    background: #ffffff;
    border-radius: 8px;
    padding-bottom: 50px;
  }
  .title {
    font-size: 15px;
    text-align: center;
    line-height: 60px;
  }
  .name {
    font-weight: 600;
    color: #000;
    padding: 0 5px;
  }
  .strength {
    display: flex;
    align-items: center;
    padding: 20px 0;
    .strength-box {
      margin-left: 5px;
    }
    .flex {
      display: flex;
      > span {
        width: 46px;
        height: 9px;
        text-align: center;
      }
      .text {
        height: 20px;
      }
    }
  }
}
</style>
